module.exports = __webpack_public_path__ + "static/fonts/element-icons.732389d.ttf";


//////////////////
// WEBPACK FOOTER
// ./theme/fonts/element-icons.ttf
// module id = 0IAQ
// module chunks = 18